import { ActionButton } from '../../components/vertical-dot/popper';

interface CellProps {
  row: any;
  cell: any;
  handleRowEdit?: any;
}

export const PlanGrantDocumentHeader = ({
  actions,
  setConfirmCustomValue,
  openConfirmModal,
}: {
  actions?: any;
  setConfirmCustomValue?: any;
  openConfirmModal?: any;
}): any[] => {
  const handleEdit = (index: any, handleRowEdit: any) => {
    handleRowEdit && handleRowEdit(index);
  };

  const renderCell = ({ row, cell, ...rest }: CellProps) => {
    return (
      <td>
        <ActionButton
          actions={[
            {
              action: 'Edit',
              onClick: (index: string) => {
                handleEdit(index, rest?.handleRowEdit);
              },
            },
            {
              action: <div className='delete-label'>Delete</div>,
              // as: 'Delete',
              onClick: (id: string) => {
                setConfirmCustomValue(row?.original?.id);
                openConfirmModal();
              },
            },
          ]}
          hideMenuOnActionClick
          // id={row?.leafRows?.[0].original.companyId?.toString()}
          id={row?.index?.toString()}
          rowData={row?.leafRows?.[0].original}
          counter={cell?.row?.index?.toString()}
          doubleTable={true}
        />
      </td>
    );
  };

  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      renderCell: true,
      Cell: renderCell,
    },
  ];

  return newActions;
};
